<div *ngIf="isMobile">
  <h5 class="mobile-nav-title" i18n>Add Customer</h5>
  <div class="mb-5 mx-3">
    <app-customer-info></app-customer-info>
  </div>
</div>

<div *ngIf="!isMobile" class="container-fluid">
  <app-header titleText="CUSTOMERS" i18n-titleText></app-header>

  <div class="card bg-light">
    <div class="card-header">
      <img src="assets/img/circle_images/customer_circle.png" alt="Customer Icon" class="card-icon" />
      <h5 i18n>Add New Customer</h5>
      <p i18n>To add a new customer, complete the form below then click submit</p>
    </div>
    <div class="card-body">
      <app-customer-info></app-customer-info>
    </div>
  </div>
</div>
